import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconRedo = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M15.4697 5.78033C15.1768 5.48744 15.1768 5.01256 15.4697 4.71967C15.7626 4.42678 16.2374 4.42678 16.5303 4.71967L20.0303 8.21967C20.1768 8.36612 20.25 8.55806 20.25 8.75C20.25 8.85169 20.2298 8.94866 20.1931 9.03709C20.1565 9.12555 20.1022 9.20842 20.0303 9.28033L16.5303 12.7803C16.2374 13.0732 15.7626 13.0732 15.4697 12.7803C15.1768 12.4874 15.1768 12.0126 15.4697 11.7197L17.6893 9.5H9C6.92893 9.5 5.25 11.1789 5.25 13.25C5.25 15.3211 6.92874 17 8.99976 17H14.5C14.9142 17 15.25 17.3358 15.25 17.75C15.25 18.1642 14.9142 18.5 14.5 18.5H8.99976C6.10021 18.5 3.75 16.1494 3.75 13.25C3.75 10.3505 6.10051 8 9 8H17.6893L15.4697 5.78033Z",
		fill: "currentColor"
	})
});
export { SvgIconRedo as ReactComponent };
